module.exports = __webpack_public_path__ + "img/气象站概览.efd99289.png";